// removed by extract-text-webpack-plugin
module.exports = {"cont":"XBW95xTegQNA9Uh5wyohd"};


//////////////////
// WEBPACK FOOTER
// ./elements/ScrollTop.scss
// module id = 1184
// module chunks = 0